import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, LogOut, RefreshCw } from 'lucide-react';
import apiClient from '../services/apiClient';
import { useAuth } from '../context/AuthContext';
import BrandLogo from '../components/BrandLogo';
import { Button } from '../components/ui/button';
import AffiliateReport from '../components/affiliates/AffiliateReport';

// Consultant affiliate area — a standalone page (no app menu): consultant
// accounts can't use Selltrix, only audit the users who signed up through
// their link.
const Affiliates = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/api/affiliates/me');
      setReport(res.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo cargar tu panel de afiliado');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <BrandLogo className="h-7" />
            <span className="hidden sm:inline text-sm text-muted-foreground">Panel de afiliados</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden md:inline text-sm text-muted-foreground truncate">{user?.name || user?.email}</span>
            <Button variant="outline" size="sm" onClick={fetchReport} disabled={loading}>
              <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            </Button>
            <Button variant="outline" size="sm" onClick={handleLogout}>
              <LogOut className="w-4 h-4 mr-1" /> Salir
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-foreground mb-1">Hola{user?.name ? `, ${user.name}` : ''}</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Comparte tu enlace: quienes se registren con él obtienen un descuento en Selltrix, y sus pagos quedan registrados aquí.
        </p>

        {loading && !report ? (
          <div className="flex justify-center py-24">
            <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
          </div>
        ) : error ? (
          <p className="text-center text-sm text-red-500 py-24">{error}</p>
        ) : (
          <AffiliateReport report={report} />
        )}
      </main>
    </div>
  );
};

export default Affiliates;
